import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfLink from '@elem/ui/ef-link';
import { throttle } from 'lodash';

type TabType = {
    text: string;
    target: string;
};
const Nav: React.FC = () => {
    const { t } = useLang('Oasis');
    const tabs: TabType[] = [
        {
            text: t('nav_tab1'),
            target: '#page-oasis-C',
        },
        {
            text: t('nav_tab2'),
            target: '#Table',
        },
        {
            text: t('nav_tab3'),
            target: '#Developer',
        },
    ];
    const [active, setActive] = useState<string>(tabs[0].target);
    let scrollY: number = 150;
    let timer: NodeJS.Timeout | number | null = null;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scrollFunc = throttle(() => {
                const sy: number = window.scrollY || document.documentElement.scrollTop;
                const IS_SCROLL_BACK: boolean = sy < scrollY;
                const nav: HTMLDivElement | null = document.querySelector(`.${css.section}`);
                if (timer) {
                    clearTimeout(timer);
                }
                if (nav) {
                    if (IS_SCROLL_BACK || sy <= 150) {
                        nav.classList.add('frost');
                        if (sy > 150) {
                            timer = setTimeout(() => {
                                nav?.classList.remove('frost');
                            }, 3000);
                        }
                    } else {
                        nav?.classList.remove('frost');
                    }
                }
                scrollY = sy;
            }, 100);
            window.addEventListener('scroll', scrollFunc);
            return () => {
                if (timer) {
                    clearTimeout(timer);
                }
                window.removeEventListener('scroll', scrollFunc);
            };
        }
    }, []);

    return (
        <div className={`page-oasis-nav ${css.section} frost`} id="page-oasis-nav">
            <div className="nav-box">
                <span className="title">{t('nav_title')}</span>
                <div className="right">
                    <ul className="tabs">
                        {tabs.map((tab: TabType) => (
                            <li className={`tab ${tab?.target === active ? 'active' : ''}`} key={tab.target} onClick={() => setActive(tab.target)}>
                                <EfLink className="tab-link" href={tab.target}>
                                    {tab.text}
                                </EfLink>
                            </li>
                        ))}
                    </ul>
                    <EfLink className="btn" href="#DownloadApp">
                        {t('nav_btn')}
                    </EfLink>
                </div>
            </div>
        </div>
    );
};

export default Nav;
